import React, { useEffect, useState } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Col, Container, Row } from "react-bootstrap";
import InputField from "../component/InputField";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import Button from "react-bootstrap/Button";
import PrimaryOutLineButton from "../component/PrimaryOutLineButton";
import PurchaseService from "../services/Purchase";
import SelectDropDown from "../component/SelectDropDown";
import Form from "react-bootstrap/Form";
import ProfileService from "../services/Profile";
import ProductService from "../services/Product";
import AlertMsg from "../component/AlertMsg";
import toast from "react-hot-toast";
import ConfirmationModal from "../component/Modals/ConfirmationModal";
import Modal from "../component/Modal";
import Loader from "../component/Loader";
import NoData from "../component/NoData";

const PurchaseApprovalAllied = () => {
  const { state } = useLocation();
  console.log("stateDATA", state);
  //Format Date
  const formatDate = (date) => {
    const dateTime = new Date(date);
    return dateTime.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });
  };
  const navigate = useNavigate();
  const { itemId } = useParams();
  const [selectedPurchaseData, setSelectedPurchaseData] = useState({
    full_name: "",
    sale_id: "",
    mobile_number: "",
    product_name: "",
    tonnage_sold: "",
    hier_id: "",
    contact_id: "",
    purchase_date: "",
    enrolled_date: "",
    proposed_area: "",
    approved_area: "",
    customer_name: "",
    full_name_dealer: "",
    full_name_purchased_by: "",
    total_consumption: "",
    site_name: "",
  });
  const [isLoginSuccess, setIsLoginSuccess] = useState({
    isLogin: true,
    heading: "",
    text: "",
  });
  const [showAlert, setShowAlert] = useState(false);
  const [editBlock, setEditBlock] = useState(false);
  const [approveReason, setApproveReason] = useState(false);
  const [rejectReason, setRejectReason] = useState(false);
  const [frmBtnShow, setFrmBtnShow] = useState(true);
  const [isReason, setIsReason] = useState("");
  const [defaultDealerList, setDefaultDealerList] = useState([]);
  const [isReasonApproveValidator, setIsReasonApproveValidator] = useState("");
  const [isDealerValidator, setIsDealerValidator] = useState("");
  const [isApproveAreaValidator, setIsApproveAreaValidator] = useState("");
  const [isReasonApproveOtherValidator, setIsReasonApproveOtherValidator] =
    useState("");
  const [isReasonList, setIsReasonList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isDealer, setIsDealer] = useState({
    id: "",
    title: "",
  });
  const [isDealerList, setIsDealerList] = useState([]);
  const [conversionFactor, setConversionFactor] = useState(0.5);
  const [selectedReason, setSelectedReason] = useState({
    id: "",
    title: "",
  });
  const [reasonOther, setReasonOther] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [proceedWithApproval, setProceedWithApproval] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [off, setOff] = useState(false);

  function reset() {
    setSelectedReason({ id: "", title: "" });
    setSelectedPurchaseData({
      full_name: "",
      sale_id: "",
      mobile_number: "",
      product_name: "",
      tonnage_sold: "",
      hier_id: "",
      contact_id: "",
      purchase_date: "",
      enrolled_date: "",
      proposed_area: "",
      approved_area: "",
      customer_name: "",
      full_name_dealer: "",
      full_name_purchased_by: "",
      total_consumption: "",
      site_name: "",
    });
  }
  //Conversion //
  const ConversionFactorData = async () => {
    const token = localStorage.getItem("access_token");
    try {
      const ConversionDataResponse = await PurchaseService.conversionFactor(
        token
      );
      console.log(
        "ConversionDataResponse",
        JSON.stringify(ConversionDataResponse)
      );
      if (ConversionDataResponse.success == true) {
        setConversionFactor(
          parseFloat(ConversionDataResponse.response.conversionDetails)
        );
      }
      if (!isNaN(conversionFactor)) {
        setConversionFactor(conversionFactor);
      }
    } catch (e) {
      console.log("ConversionError", e);
    }
  };
  useEffect(() => {
    ConversionFactorData();
  }, []);
  //Dealer List
  useEffect(() => {
    const DealerListFetch = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const DealerResponse = await PurchaseService.getPreviousDealersForSaleApproval(
          itemId
        );
        console.log("DealerResponse", JSON.stringify(DealerResponse));
        if (
          DealerResponse.success == true 
        ) {
          let allDealers = DealerResponse.response.dealerDetails;
          const filteredDataDealer = allDealers.map(
            (item) => {
              return {
                id: item.id,
                title:
                  item.full_name +
                  " (" +
                  item.dealer_business_name +
                  " - " +
                  item.id_extern01 +
                  ")",
              };
            }
          );

          const deafultDealer = {
            id: state.dealer_id,
            title: `${state.dealer_name} (${state.dealer_business_name} - ${state.id_extern01})`,
          };
          setIsDealer(deafultDealer)
          setDefaultDealerList(filteredDataDealer);
          // "deafultDealer":{"full_name":"Lalit Upadhyay Dealer ACL","dealer_business_name":"JK Trades","name":"DEALER ACL","id_extern01":"1312424","dcm_contacts_id":47219,"parent_contact_id":65207}
          const defaultDealer = DealerResponse.response?.deafultDealer;
          const deafultDealerInfo = {
            id: defaultDealer.dcm_contacts_id,
            title:
              defaultDealer.full_name +
              " (" +
              defaultDealer.dealer_business_name +
              " - " +
              defaultDealer.id_extern01 +
              ")",
          };
          setIsDealer(deafultDealerInfo);
        }
      } catch (e) {
        console.log("DealerListError", e);
      }
    };
    DealerListFetch();
  }, []);
  //Selected Data
  useEffect(() => {
    const PurchaseApprovalDataFetch = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("access_token");
        const PurchaseApprovalDataResponse =
          await PurchaseService.purchaseApprovalWeb(itemId);
        console.log("TestData", JSON.stringify(PurchaseApprovalDataResponse));
        // const productDetails = await ProductService.productDetailsWeb(token, PurchaseApprovalDataResponse.response.saleData.dcm_product_master_id, PurchaseApprovalDataResponse.response.saleData.category_id)
        // console.log('productDetails', productDetails);

        let dcm_contacts_id = await PurchaseApprovalDataResponse.response
          .saleData.dcm_contacts_id;
        // if(!PurchaseApprovalDataResponse) {
        //     navigate(`/purchase-registration-list`);
        // }
        const profile = await ProfileService.getProfile(dcm_contacts_id);
        const profileDetails = profile.response.message;
        console.log("Profile", profileDetails);
        setSelectedPurchaseData({
          ...selectedPurchaseData,
          full_name: profileDetails.full_name,
          // number: profileDetails.phone_number,
          tonnage_sold:
            PurchaseApprovalDataResponse.response.saleData.claimed_quantity,
          sale_id: PurchaseApprovalDataResponse.response.saleData.id,
          hier_id: profileDetails.hierarchies_id,
          contact_id: dcm_contacts_id,
          mobile_number:
            PurchaseApprovalDataResponse.response.saleData.mobile_number,
          site_name: PurchaseApprovalDataResponse.response.saleData.site_name,
          full_name_purchased_by:
            PurchaseApprovalDataResponse.response.saleData
              .full_name_purchased_by,
          full_name_dealer:
            PurchaseApprovalDataResponse.response.saleData.full_name_dealer,
          customer_name:
            state.customer_name,
          product_name:
            PurchaseApprovalDataResponse.response.saleData.product_name,
          purchase_date:
            PurchaseApprovalDataResponse.response.saleData.sale_date,
          enrolled_date:
            PurchaseApprovalDataResponse.response.saleData.created_at,
          proposed_area:
            state.proposed_area,
          total_consumption: !state.approved_area
          ? Number(state.proposed_area) *
            conversionFactor
          : Number(state.approved_area) *
            conversionFactor,
          approved_area: !state.approved_area
            ? state.proposed_area
            : state.approved_area,
          // ...state,
          conFactor: conversionFactor,
          ...state
        });
        // item.approved_area ? item.approved_area : item.proposed_area
        console.log("Array--->", state?.disable_approve_flag);
        
        console.log("Proposed area---->", state?.proposed_area);
        console.log("Approved area---->", !state.approved_area
          ? state.proposed_area
          : state.approved_area);
        
        console.log(
          "selectedPurchaseData",
          JSON.stringify({
            ...selectedPurchaseData,
            full_name: profileDetails.full_name,
            // number: profileDetails.phone_number,
            tonnage_sold:
              PurchaseApprovalDataResponse.response.saleData.claimed_quantity,
            sale_id: PurchaseApprovalDataResponse.response.saleData.id,
            hier_id: profileDetails.hierarchies_id,
            contact_id: dcm_contacts_id,
            mobile_number:
              PurchaseApprovalDataResponse.response.saleData.mobile_number,
            site_name: PurchaseApprovalDataResponse.response.saleData.site_name,
            full_name_purchased_by:
              PurchaseApprovalDataResponse.response.saleData
                .full_name_purchased_by,
            full_name_dealer:
              PurchaseApprovalDataResponse.response.saleData.full_name_dealer,
            customer_name:
              PurchaseApprovalDataResponse.response.saleData.customer_name,
            product_name:
              PurchaseApprovalDataResponse.response.saleData.product_name,
            purchase_date:
              PurchaseApprovalDataResponse.response.saleData.sale_date,
            enrolled_date:
              PurchaseApprovalDataResponse.response.saleData.created_at,
            proposed_area:
              state.proposed_area,
            total_consumption: !PurchaseApprovalDataResponse.response.saleData
            .approved_area
            ? Number(state.proposed_area) *
              conversionFactor
            : PurchaseApprovalDataResponse.response.saleData.approved_area *
              conversionFactor,
            approved_area: !state.approved_area
              ? state.proposed_area
              : state.approved_area,
            // ...state,
            conFactor: conversionFactor
          })
        );
        if(state?.disable_approve_flag && state?.disable_approve_flag.name === 'disableApproveFlag') {
          setOff(true);

        }
      } catch (error) {
        console.error("Purchase Approval Data Fetch", error);
      } finally {
        setLoading(false);
      }
    };
    PurchaseApprovalDataFetch();
  }, []);

  //Reason
  useEffect(() => {
    const reasonDataFetch = async () => {
      try {
        if (isReason) {
          const token = localStorage.getItem("access_token");
          const reasonDataResponse =
            await PurchaseService.reasonsApprovalAndRejection(
              isReason,
              state?.hier_id
            );

          if (reasonDataResponse.success == true) {
            const reason = reasonDataResponse.response.reasonsList?.map(
              (item, index) => {
                return {
                  id: item.id,
                  title: item.reasons,
                };
              }
            );
            setIsReasonList(reason);
          }
        }
      } catch (error) {
        console.error("Reason Data Fetch", error);
      }
    };
    reasonDataFetch();
  }, [isReason]); //
  const handleApprove = () => {
    setApproveReason(true);
    setFrmBtnShow(false);
    setEditBlock(false);
    setIsReason("accept");
  };
  const handleReject = () => {
    setRejectReason(true);
    setFrmBtnShow(false);
    setEditBlock(false);
    setIsReason("reject");
  };
  const handleApproveBack = () => {
    setApproveReason(false);
    setFrmBtnShow(true);
    setSelectedReason("");
  };
  const handleRejectBack = () => {
    setFrmBtnShow(true);
    setRejectReason(false);
    setSelectedReason("");
  };
  const handleReasonChange = (selectedValue) => {
    setSelectedReason(selectedValue);
    setIsReasonApproveValidator("");
  };
  const handleOtherChange = (event) => {
    setReasonOther(event.target.value);
    setIsReasonApproveOtherValidator("");
  };

  const handlePurchaseASubmit = async () => {
    try {  
      const payload = {
        accept_or_reject: isReason === "accept" ? "accept" : "reject",
        reasons: selectedReason.title,
        contact_id_contractor: selectedPurchaseData.contact_id,
        sale_id: parseInt(selectedPurchaseData.sale_id),
        other_reason: reasonOther,
        customer_name: selectedPurchaseData.customer_name,
        mobile_number: selectedPurchaseData?.number,
        site_name: selectedPurchaseData.site_name,
        approved_area: selectedPurchaseData.approved_area || selectedPurchaseData.proposed_area,
        dealer_id: selectedPurchaseData?.dealer_id,
      };
      console.log("Payload----------->", payload);
      
      setLoading(true);
      // const toastid = toast.loading("Loading...");
      console.log("========Calling Accept or Reject===========");
      
      const response = await PurchaseService.acceptOrRejectAllied(payload);
      reset();
      // toast.dismiss(toastid);
      setLoading(false);
      if (response.success && response.response.salesResult.status) {
        toast.success(response.response.salesResult.message);
        navigate("/allied-purchase-list")
      } else {
        toast.error(response.response.salesResult.message);
      }
    } catch (e) {
      console.error("PurchaseApproval Error", e);
      toast.error("Something went wrong. Please try again.");
      setLoading(false);
    }
  };
  
const handlePurchaseApprovalSubmit = async () => {
  const tseGeoLocationCode = state.tseGeoLocation?.[0]?.ext_sales_office_code;
  if(state.dealer_sales_office === tseGeoLocationCode) {
    let isValidate = true;

    if (!selectedReason.title) {
      toast.error("Reason required");
      return;
    }

    if (selectedReason.title === "Others" && !reasonOther) {
      toast.error("Reason required");
      return;
    }

    if (approveReason === "accept" && !selectedPurchaseData.dealer_id) {
      toast.error("Please edit and choose your dealer");
      return;
    }
    await handlePurchaseASubmit();
    setTimeout(() => {
      navigate("/allied-purchase-list");
    }, 3000);
  } else {
    console.log("Mismatch found, opening modal...");
    setShowModal(true);
    setShowConfirmationModal(true);
  }
};

  const handleEdit = () => {
    setEditBlock(true);
    setFrmBtnShow(false);
  };
  const handleDealerChange = (selected) => {
    setIsDealer(selected);
    setIsDealerValidator("");
  };
  const handleApprovedArea = (e) => {
    const newApprovedArea = e.target.value;
    if(isNaN(Number(newApprovedArea))) return;
    if(String(newApprovedArea).length >= 7) return;
    const numericArea = parseFloat(newApprovedArea);
    if (numericArea === 0) {
      toast.error("Approved Build-up Area (Sq ft.) can't be 0");
      return;
    }
    setSelectedPurchaseData({
      ...selectedPurchaseData,
      approved_area: newApprovedArea,
      total_consumption: (newApprovedArea === "" ? 0 : newApprovedArea) * conversionFactor,
    });
  };
  // parseInt(selectedPurchaseData?.approved_area ?? selectedPurchaseData?.proposed_area) * conversionFactor
  const handleEditBack = () => {
    setEditBlock(false);
    setFrmBtnShow(true);
  };
  const handlePurchaseEdit = async () => {
    let validateData = true;
    // if (!isDealer.id) {
    //     setIsDealerValidator('Dealer is required')
    //     validateData = false
    // }
    // if (!selectedPurchaseData?.approved_area) {
    //     setIsApproveAreaValidator('Approved Area is required')
    //     validateData = false
    // }

    if (validateData) {
      const saleId = itemId;
      if (!(selectedPurchaseData?.approved_area != "" ?? selectedPurchaseData?.proposed_area)) {
        toast.error("Approved area required");
        return;
      }

      if (
        parseInt(selectedPurchaseData.approved_area) >
        parseInt(selectedPurchaseData.proposed_area)
      ) {
        toast.error(
          "Approved build-up area cannot be more than total buildup area"
        );
        return;
      }

      if (!isDealer.id) {
        toast.error("Please choose your dealer");
        return;
      }
      // const toastid = toast.loading("Loading...");
      
      try {

        const payload = {
          customer_name: selectedPurchaseData.customer_name,
          mobile_number: selectedPurchaseData.mobile_number,
          site_name: state.site_name ?? "",
          approved_area: selectedPurchaseData?.approved_area,
          dealer_contact_id: isDealer.id,
          customer_map_id: state.customer_map_id,
        };
        console.log("Payloadddd", JSON.stringify(payload));

        setLoading(true);
        
        const handlePurchaseEditSubmission = await PurchaseService.editPurchase(
          saleId,
          payload
        );
        console.log(
          "handlePurchaseEditSubmission",
          JSON.stringify(handlePurchaseEditSubmission)
        );
        // toast.dismiss(toastid);
        setLoading(false);
        if (handlePurchaseEditSubmission.success == true) {
          if (handlePurchaseEditSubmission.response.updateStatus == "true")
            toast.success(handlePurchaseEditSubmission.response.message);
          reset();
          setTimeout(() => {
            navigate("/purchase-registration-list");
          }, 1000);
        } else {
          setShowAlert(true);
          // toast.dismiss(toastid);
          setLoading(false);
          toast.error(handlePurchaseEditSubmission?.response?.message);
        }
      } catch (e) {
        console.log("handlePurchaseEditSubmissionError", e);
        // toast.dismiss(toastid);
        toast.error("Cannot process your request")
      }
    }
  };

  return (
    <>
      {/* {loading && <Loader />} */}
      <BreadCrumbSecttion
        pageTitle="Allied Purchase Approval"
        currentPageName="Allied Purchase Approval"
      />
      <section className="padTop50">
        <Container>
          <Row className="justify-content-center align-item-center h-100">
            <Col xs={12}>
              <div className="userInfoBox">
                <div className="dashboard-title">
                  <h4>Please Check The Purchase Register Request</h4>
                </div>
                {<div className="dashboard-details purchaseApprovalWrap">
                  <Row>
                    <Col xs={12} lg={3}>
                      <InputField
                        inputFieldLabel="Transaction Id"
                        value={selectedPurchaseData?.sale_id}
                        editable={false}
                      />
                    </Col>
                    <Col xs={12} lg={3}>
                      <InputField
                        inputFieldLabel="Quantity"
                        value={Number(
                          selectedPurchaseData?.tonnage_sold
                        ).toFixed(2)}
                        editable={false}
                      />
                    </Col>
                    <Col xs={12} lg={3}>
                      <InputField
                        inputFieldLabel="Description"
                        value={selectedPurchaseData?.product_name}
                        editable={false}
                      />
                    </Col>
                    <Col xs={12} lg={3}>
                      <InputField
                        inputFieldLabel="Purchase Date"
                        value={selectedPurchaseData?.purchase_date}
                        editable={false}
                      />
                    </Col>
                    <Col xs={12} lg={3}>
                      <InputField
                        inputFieldLabel="Enrolled Date"
                        value={formatDate(selectedPurchaseData?.enrolled_date)}
                        editable={false}
                      />
                    </Col>
                    {!editBlock && <Col xs={12} lg={3}>
                      <InputField
                        inputFieldLabel="Approved build-up area (Sq ft.)"
                        value={selectedPurchaseData?.approved_area || selectedPurchaseData?.proposed_area}
                        editable={false}
                      />
                    </Col>}
                    <Col xs={12} lg={3}>
                      <InputField
                        inputFieldLabel="Total Build-up Area (Sq ft.)"
                        requiredStar={editBlock == false ? "" : "*"}
                        value={editBlock ? selectedPurchaseData?.approved_area : selectedPurchaseData?.proposed_area}
                        editable={editBlock == false ? false : true}
                        onChange={handleApprovedArea}
                        name="total build up"
                      />
                    </Col>

                    <Col
                      xs={12}
                      lg={3}
                      className={editBlock == false ? "" : "whiteNonEditField"}
                    >
                      <InputField
                        inputFieldLabel="Total Conumptions (Bags)"
                        value={
                         selectedPurchaseData.total_consumption
                        }
                        editable={false}
                      />
                      {/* {isApproveAreaValidator && (
                        <div className="error-message">
                          {isApproveAreaValidator}
                        </div>
                      )} */}
                    </Col>
                    <Col xs={12} lg={3}>
                      <InputField
                        inputFieldLabel="Customer Name"
                        value={selectedPurchaseData?.customer_name}
                        editable={false}
                      />
                    </Col>
                    <Col xs={12} lg={3}>
                                            <InputField inputFieldLabel='Dealer'
                                                value={selectedPurchaseData?.full_name_dealer}
                                                editable={false} />
                                        </Col>
                    <Col xs={12} lg={3}>
                      <InputField
                        inputFieldLabel="Purchased By"
                        value={selectedPurchaseData?.full_name_purchased_by}
                        editable={false}
                      />
                    </Col>
                    {approveReason && (
                      <>
                        <Col xs={12} lg={3}>
                          <SelectDropDown
                            requiredStar="*"
                            labelName="Reasons"
                            options={isReasonList}
                            selectedValue={selectedReason}
                            setSelectedValue={setSelectedReason}
                            onChange={handleReasonChange}
                          />
                          {isReasonApproveValidator && (
                            <div className="error-message">
                              {isReasonApproveValidator}
                            </div>
                          )}
                        </Col>
                        {selectedReason.title == "Others" && (
                          <Col xs={12} lg={3}>
                            <Form.Label>
                              Reason of Approval
                              <span className="redStar">*</span>{" "}
                            </Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              className="h-48"
                              value={reasonOther}
                              onChange={handleOtherChange}
                            />
                            {isReasonApproveOtherValidator && (
                              <div className="error-message">
                                {isReasonApproveOtherValidator}
                              </div>
                            )}
                          </Col>
                        )}
                        <Col xs={12} lg={3}>
                          <PrimaryOutLineButton
                            outlinebuttonText="Back"
                            className="mt-4"
                            onClick={handleApproveBack}
                          />
                        </Col>
                        <Col xs={12} lg={3}>
                          <PrimaryGradientButton
                            buttonText="Submit"
                            className="mt-4"
                            onClick={handlePurchaseApprovalSubmit}
                          />
                        </Col>

                        {showAlert && (
                          <Col xs={12} lg={6} className="mt-3">
                            <AlertMsg
                              alertBoxColor={
                                isLoginSuccess.isLogin
                                  ? "successAlert"
                                  : "FailedAlert"
                              }
                              heading={isLoginSuccess.heading}
                              text={isLoginSuccess.text}
                            />
                          </Col>
                        )}
                      </>
                    )}
                    {editBlock && (
                      <>
                        <Col xs={12} lg={3}>
                          {/* <SelectDropDown
                            requiredStar="*"
                            page="searchFilter"
                            labelName="Choose Dealer /ARS /Retailer"
                            options={isDealerList}
                            selectedValue={isDealer}
                            setSelectedValue={setIsDealer}
                            onChange={handleDealerChange}
                          /> */}
                           <Modal
                          labelName="Choose Dealer/ARS/Retailer"
                          requiredStar="*"
                          screen={'purchaseApproval'}
                          page='searchFilter'
                          options={defaultDealerList}
                          setSelectedValue={setIsDealer}
                          selectedValue={isDealer}
                          onChange={handleDealerChange}
                        />
                          {isDealerValidator && (
                            <div className="error-message">
                              {isDealerValidator}
                            </div>
                          )}
                        </Col>

                        <Col xs={12} lg={3}>
                          <PrimaryOutLineButton
                            outlinebuttonText="Back"
                            className="mt-4"
                            onClick={handleEditBack}
                          />
                        </Col>
                        <Col xs={12} lg={3}>
                          <PrimaryGradientButton
                            buttonText="Submit"
                            className="mt-4"
                            onClick={handlePurchaseEdit}
                          />
                        </Col>
                        {showAlert && (
                          <Col xs={12} lg={6} className="mt-4">
                            <AlertMsg
                              alertBoxColor={
                                isLoginSuccess.isLogin
                                  ? "successAlert"
                                  : "FailedAlert"
                              }
                              heading={isLoginSuccess.heading}
                              text={isLoginSuccess.text}
                            />
                          </Col>
                        )}
                      </>
                    )}
                    {rejectReason && (
                      <>
                        <Col xs={12} lg={3}>
                          <SelectDropDown
                            requiredStar="*"
                            labelName="Reasons"
                            options={isReasonList}
                            selectedValue={selectedReason}
                            setSelectedValue={setSelectedReason}
                            onChange={handleReasonChange}
                          />
                          {isReasonApproveValidator && (
                            <div className="error-message">
                              {isReasonApproveValidator}
                            </div>
                          )}
                        </Col>
                        {selectedReason.title == "Others" && (
                          <Col xs={12} lg={3}>
                            <Form.Label>
                              Reason of Rejection
                              <span className="redStar">*</span>{" "}
                            </Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              className="h-48"
                              value={reasonOther}
                              onChange={handleOtherChange}
                            />
                            {isReasonApproveOtherValidator && (
                              <div className="error-message">
                                {isReasonApproveOtherValidator}
                              </div>
                            )}
                          </Col>
                        )}
                        <Col xs={12} lg={3}>
                          <PrimaryOutLineButton
                            disabled={loading}
                            outlinebuttonText="Back"
                            className="mt-4"
                            onClick={handleRejectBack}
                          />
                        </Col>
                        <Col xs={12} lg={3}>
                          <PrimaryGradientButton
                            disabled={loading}
                            buttonText="Submit"
                            className="mt-4"
                            // onClick={handlePurchaseApprovalSubmit}
                            onClick={() => {
                              if (state.dealer_sales_office !== state.tseGeoLocation?.[0]?.ext_sales_office_code) {
                                setShowConfirmationModal(true);
                              } else {
                                handlePurchaseApprovalSubmit();
                              }
                            }} 
                          />
                        </Col>
                        {showAlert && (
                          <Col xs={12} lg={6} className="mt-3">
                            <AlertMsg
                              alertBoxColor={
                                isLoginSuccess.isLogin
                                  ? "successAlert"
                                  : "FailedAlert"
                              }
                              heading={isLoginSuccess.heading}
                              text={isLoginSuccess.text}
                            />
                          </Col>
                        )}
                      </>
                    )}
                  </Row>

                  {/* {off && <Row className="justify-content-center align-item-center h-100">
                    <p style={{ color: '#74777cff' }}>{state.disable_approve_flag.description}</p>
                  </Row>} */}
                  {off && (
                    <Row
                      className="align-items-center"
                      style={{
                        width: "100%",
                        padding: "16px 20px",
                        background: "#fff7e6",
                        border: "1px solid #ffd591",
                        borderRadius: "8px",
                        marginTop: "10px"
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
      
                        {/* Icon */}
                        <span style={{ fontSize: "18px" }}>⚠️</span>

                        {/* Text */}
                        <div>
                          {state.disable_approve_flag.description
                            ?.split("|")
                            .map((line, index) => (
                            <p
                              key={index}
                              style={{
                                margin: 0,
                                color: "#874d00",
                                fontSize: "14px",
                                lineHeight: "20px",
                                fontWeight: index === 0 ? "600" : "400"
                              }}
                            >
                              {line.trim()}
                            </p>
                          ))}
                        </div>

                     </div>
                  </Row>
                )}

                  {selectedPurchaseData && frmBtnShow && (
                    <Row className="mt-3">
                      {/* {!off && <Col xs={12} lg={3}>
                        <PrimaryGradientButton
                          buttonText="Edit"
                          className="h-48"
                          onClick={handleEdit}
                          disabled={off || !selectedPurchaseData.sale_id}
                        />
                      </Col>} */}
                      {!off && <Col xs={12} lg={3}>
                        <Button
                          variant="success"
                          className="w-100 h-48"
                          onClick={handleApprove}
                          disabled={off ||!selectedPurchaseData.sale_id}
                        >
                          Approve
                        </Button>
                      </Col>}
                      <Col xs={12} lg={3}>
                        <Button
                          variant="danger"
                          className="w-100 h-48"
                          onClick={handleReject}
                          disabled={!selectedPurchaseData.sale_id}
                        >
                          Reject
                        </Button>
                      </Col>
                    </Row>
                  )}
                </div>}
              </div>
            </Col>
          </Row>
        </Container>
        {/* Confirmation Modal */}
        <ConfirmationModal
          show={showConfirmationModal}
          onHide={() => setShowConfirmationModal(false)}
          onConfirm={() => {
            setShowConfirmationModal(false);
            handlePurchaseASubmit();
          }}
          title="Alert"
          message="Dealer's sales office does not match TSE Geo location. Do you want to proceed?"
        />
      </section>
    </>
  );
};

export default PurchaseApprovalAllied;
